<template>
  <v-app light class="tw-font-sans tw-antialiased">
    <router-view/>
  </v-app>
  <!--<div class="app tw-bg-grey-light">-->
    <!--<router-view/>-->
  <!--</div>-->
</template>

<script>
export default {
  name: 'App',

  data: () => ({
  }),

  props: {
  }
}
</script>

<style lang="scss">
  @import './design/index.scss';
</style>
